// KPI hücre not iş parçacığı (portal yetki v2 Dalga 3 — spec 2026-10-23 §3.2, §6, §7; migration 0064).
// Hücre anahtarı `kpi_values` beşlisiyle aynı (müşteri × gösterge × işletme × yıl × dönem); değer satırı
// gerekmez. Not `kpi_values`'a YAZILMAZ (Y7) — sürüm/bayatlık/DR8 etkilenmez. DOCX/Excel/snapshot/AI
// prompt'una girmez.

import { z } from "zod";

/** Gövde tavanı — DB CHECK (char_length 1..2000) ile aynı. Aşım 422 `note_too_long`. */
export const KPI_NOTE_BODY_MAX = 2000;

/** Thread hücresi (portal/iç GET sorgusu + `notes/seen` gövdesi). Dönem: yıllık (K24). */
export const KpiNoteCellSchema = z.object({
  metricId: z.string().uuid(),
  entityId: z.string().uuid(),
  year: z.coerce.number().int().min(1990).max(2100),
});
export type KpiNoteCell = z.infer<typeof KpiNoteCellSchema>;

/**
 * Not yazımı. Boş ya da yalnız boşluk gövde 422 `note_empty`, tavan aşımı 422 `note_too_long`
 * (route Zod sorununu bu kodlara çevirir). Aynı `clientRequestId` ikinci kez → 200 + mevcut satır.
 */
export const KpiNoteCreateSchema = KpiNoteCellSchema.extend({
  body: z.string().min(1).max(KPI_NOTE_BODY_MAX),
  clientRequestId: z.string().uuid().optional(),
});
export type KpiNoteCreate = z.infer<typeof KpiNoteCreateSchema>;

export const KPI_NOTE_AUTHOR_KINDS = ["client", "internal"] as const;
export type KpiNoteAuthorKind = (typeof KPI_NOTE_AUTHOR_KINDS)[number];

export interface KpiValueNoteDto {
  id: string;
  authorKind: KpiNoteAuthorKind;
  /** Yazar silinmişse null (FE "Müşteri" / "Danışman" gösterir). */
  authorName: string | null;
  body: string;
  createdAt: string;
  /** İsteği yapan kullanıcı mı yazdı. */
  mine: boolean;
}

/**
 * Hücre başına özet (note-summary). `unread` = karşı taraftan gelip henüz açılmamış mesaj sayısı
 * (taraf bazlı — `seen_by_counterpart_at`). `lastAuthorKind`: son mesajın tarafı — danışman Özet'inin
 * "Yanıt bekleyen notlar" listesi son mesajı müşteriden olan hücrelerdir.
 */
export interface KpiNoteSummaryCell {
  metricId: string;
  entityId: string;
  year: number;
  count: number;
  unread: number;
  lastAuthorKind: KpiNoteAuthorKind;
}
